// Do not promote legacy cached counts (or a stored verified_task flag) into proof.
// The backend marks its read-only projection after checking live task evidence.
export function publicReputation(expert) {
  const trusted = expert.public_reputation?.source === 'completed_paid_tasks';
  return {
    hasRating: trusted && expert.rating_count > 0 && expert.rating_avg >= 1 && expert.rating_avg <= 5,
    completedCount: trusted ? expert.public_reputation.completed_count || 0 : 0,
    reviews: trusted ? expert.reviews || [] : [],
  };
}
